export default {
  eligibleCampaigns: [],
  participatedCampaigns: [],
  claimedStaus: false,
  claimedCheckedStaus: false,
  eligibleCampaignsMap: [],
}
